// @flow
// FlyerGrid Container
/* global window */

function getConfig(domain) {
  switch (domain) {
    case 'app.peachjar-kauai.com':
      return {
        REACT_APP_ENV: 'development',
        REACT_APP_API_HOST_NAME: 'https://api-stg.peachjar-kauai.com',
        V2_API_HOST_NAME: 'https://portal-bff.peachjar-kauai.com'
      }
    case 'app.peachjar.com':
      return {
        REACT_APP_ENV: 'production',
        REACT_APP_API_HOST_NAME: 'https://api-prd.peachjar.com',
        V2_API_HOST_NAME: 'https://portal-bff.peachjar.com'
      }
    default:
      return {
        REACT_APP_ENV: 'development',
        REACT_APP_API_HOST_NAME: 'http://localhost:50001',
        V2_API_HOST_NAME: 'http://localhost:41002'
      }
  }
}

export default getConfig(window.location.hostname)



// WEBPACK FOOTER //
// ./src/config.js